import { isDraft } from '@reduxjs/toolkit';

const reorder = (items, source, destination) => {
  const newItems = Array.from(items);
  const [reorderedItem] = newItems.splice(source, 1);
  newItems.splice(destination, 0, reorderedItem);
  return newItems;
};

const useDragAndDrop = ({ modules, updateMultipleModules, updateLesson }) => {
  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const { type, draggableId } = result;

    // Obtenemos el origen y el destino del elemento reordenado.
    const source = result.source.index;
    const destination = result.destination.index;

    // Si es el mismo origen y destino, no hacemos nada.
    if (source === destination) {
      return;
    }

    // Si el modulo es reordenado, su valor es tipo "Modules"
    if (type === 'Modules') {
      const newModules = reorder(modules, source, destination);
      updateMultipleModules(newModules);
      return;
    }

    // DraggableId es el id de la leccion que se esta reordenando.
    const currentLessonId = draggableId;

    // Si las lecciones son reordenadas, su valor es tipo "index" del modulo.
    const index = type;

    // Obtenemos las "lessons" actuales del modulo.
    const { lessons } = modules[index];

    // Reordenamos las lecciones a lo indicado por el usuario.
    const orderedLessons = reorder(lessons, source, destination);

    // Actualizamos las lecciones del modulo actual.
    modules[index].lessons = orderedLessons;

    const currentLesson = orderedLessons.find(lesson => lesson?.id === currentLessonId);

    // Si no hay lección quiere decir que no tenía un ID, si no un index.
    if (!currentLesson) {
      updateLesson({ index: destination });
      return;
    }

    // Mandamos a actualizar la leccion modificada.
    updateLesson({
      id: currentLesson.id,
      file: currentLesson.file,
      order: destination + 1,
      name: currentLesson.name,
      isDraft: !!currentLesson.isDraft,
      isPrivate: !!currentLesson.isPrivate,
    });
  };
  return { onDragEnd };
};

export default useDragAndDrop;
